import { configureStore } from '@reduxjs/toolkit';
import projectsReducer from './reducers/ProjectsSlice';
import authReducer from './store/slices/authSlice';

export const store = configureStore({
    reducer: {
        projects: projectsReducer,
        auth: authReducer,
    },
});